import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  Skeleton,
} from '@parcel/ui';

/**
 * The height the Chats section is about to take, while it is still finding out.
 *
 * Its own module, and deliberately free of any Spec runtime import: AppSidebar
 * renders this as the lazy chunk's fallback, so pulling it from the chunk it is
 * standing in for would defeat the lazy boundary and put `@assistant-ui/react`
 * back in the entry bundle.
 */
export function SpecSidebarChatsSkeleton() {
  return (
    <SidebarGroup className="pt-0" data-testid="spec-sidebar-chats-skeleton">
      <SidebarGroupLabel>Chats</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {[0, 1, 2, 3].map((row) => (
            <SidebarMenuItem key={row}>
              <div className="flex h-8 items-center gap-2 px-2">
                <Skeleton className="size-2 shrink-0 rounded-full" />
                <Skeleton className="h-3 w-28" />
              </div>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
